import React, { useEffect } from "react";
import {
  HeaderText,
  HeaderTextBold,
} from "../../../styles/addMobileSocial";
import {
  LoadingOverlay,
  LoadingSpinner,
  LoadingSpinnerIcon,
} from "../../../styles/loading";
import {
  ErrorText,
  FormContainer,
  FormGroup,
  FullWidthContainer,
  Input,
  InputField,
  Label,
} from "../../../styles/PersonalInfoStep";
import { PatternValidators, validPattern } from "../../../utils/validators";

interface IProps {
  token: string;
  callback: Function;
}

export default function AddMobileSocial(props: IProps) {
  const [submitBtnClick, setSubmitBtnClick] = React.useState(false);
  const [loading, setLoading] = React.useState(false);


  
  const [values, setValues] = React.useState({
    mobile: "",
  });

  const [errors, setErrors] = React.useState<Record<string, boolean>>({
    mobile: true,
  });

  useEffect(() => {
    setSubmitBtnClick(false)
    setLoading(false)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    setValues({ ...values, [name]: value });
    validateField(name, value);
  };

  const validateField = async (prop: any, value: any) => {
    let isValid: boolean = true;

    try {
      switch (prop) {
        case "mobile": {
          isValid = await validPattern({
            paramPattern: value,
            patternType: "mobile",
          });
          break;
        }
      }
    } catch (err) {}

    setErrors((prev) => ({
      ...prev,
      [prop]: !isValid, // Invert the error state to match your validation logic
    }));

    return isValid;
  };


  return (
    <>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner>
            <LoadingSpinnerIcon />
          </LoadingSpinner>
        </LoadingOverlay>
      )}
      <FormContainer>
        <HeaderText>
          <HeaderTextBold>Please add your Phone Number.</HeaderTextBold>
        </HeaderText>

        
        <FormGroup>
          <FullWidthContainer>
            <Label>Mobile*</Label>
            <InputField $hasError={!!errors.mobile}>
              <Input
                type="text"
                name="mobile"
                placeholder="Enter mobile number"
                value={values.mobile}
                onChange={handleChange}
                $hasError={!!errors.mobile}
                className="ml-negative-16"
                color="#34A853"
              />
            </InputField>
          </FullWidthContainer>
        </FormGroup>
        {submitBtnClick && errors.mobile && (
          <ErrorText>
            <PatternValidators
              paramPattern={values.mobile}
              patternType="mobile"
              textType="Mobile"
            />
          </ErrorText>
        )}
      </FormContainer>
    </>
  );
}
